import React, { FC } from 'react';

import { Illustration, IllustrationProps } from '../IllustrationWrapper';

export const Smartphone: FC<IllustrationProps> = ({ size, color }) => (
  <Illustration size={size} color={color}>
    <path d="M50 4.1001H30C23.37 4.1001 18 9.4701 18 16.1001V64.0001C18 70.6301 23.37 76.0001 30 76.0001H50C56.63 76.0001 62 70.6301 62 64.0001V16.1001C62 9.4701 56.63 4.1001 50 4.1001ZM58 64.0001C58 68.4101 54.41 72.0001 50 72.0001H30C25.59 72.0001 22 68.4101 22 64.0001V16.1001C22 11.6901 25.59 8.1001 30 8.1001H37.15C37.54 9.3101 38.66 10.2001 40 10.2001C41.34 10.2001 42.46 9.3201 42.85 8.1001H50C54.41 8.1001 58 11.6901 58 16.1001V64.0001ZM50 66.0001C50 67.1001 49.1 68.0001 48 68.0001H32C30.9 68.0001 30 67.1001 30 66.0001C30 64.9001 30.9 64.0001 32 64.0001H48C49.1 64.0001 50 64.9001 50 66.0001Z" />
  </Illustration>
);
